import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    isAccountConfigured: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/isaccountconfigured`
    },
    sendUserInvitations: {
        method: 'POST',
        url: `${BASE_PATH_API}/inspections/sendUserInvitations`
    },
    getStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/provision/status`
    },
    getStatusCached: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/provision/status`,
        cache: true
    },
    provision: {
        method: 'POST',
        url: `${BASE_PATH_API}/inspections/provision`
    },
    getBillingInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/billing`,
        cache: true // This is used to prevent duplicate calls in inspections landing page and inspections cost banner services
    },
    getInspectionPricing: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/pricing`,
        cache: true // This is used to prevent duplicate calls in inspections landing page and inspections cost banner services
    },
    getCostToUpgradeSubscriptionToYearly: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/costToUpgradeSubscriptionToYearly`,
        cache: true // This is used to prevent duplicate calls in inspections landing page and inspections cost banner services
    },
    upgradeSubscriptionToYearly: {
        method: 'POST',
        url: `${BASE_PATH_API}/inspections/upgradeSubscriptionToYearly`
    },
    pushUnitToHappyCo: {
        method: 'POST',
        url: `${BASE_PATH_API}/inspections/property/:propertyId/unit/:unitId`
    }
};

export function InspectionsApi() {
    return createActions(actions);
}
